import { render } from "./BrandBlock.vue?vue&type=template&id=29937057"
import script from "./BrandBlock.vue?vue&type=script&lang=js"
export * from "./BrandBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/BrandBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29937057"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29937057', __exports__)) {
    api.reload('29937057', __exports__)
  }
  
  module.hot.accept("./BrandBlock.vue?vue&type=template&id=29937057", () => {
    api.rerender('29937057', render)
  })

}


export default __exports__